import Localization from 'lib/localization';

export default {
    lxSeoPageTitleIndex(params: { page_partner_name: string }) {
        return Localization.get('badoo_safety_center@seo.page.title.index', params);
    },
    lxSeoPageTitleGuidesSectionHarmfulBehaviour(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.harmful_behaviour',
            params
        );
    },
    lxSeoPageTitleGuidesSectionHarmfulBehaviourArticleTwo(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.two',
            params
        );
    },
    lxSeoPageTitleGuidesSectionHarmfulBehaviourArticleThree(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.three',
            params
        );
    },
    lxSeoPageTitleGuidesSectionHarmfulBehaviourArticleFourth(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.fourth',
            params
        );
    },
    lxSeoPageTitleGuidesSectionHarmfulBehaviourArticleFifth(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.harmful_behaviour.article.fifth',
            params
        );
    },

    lxSeoPageTitleGuidesSectionMeetingInRealLife(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life',
            params
        );
    },
    lxSeoPageTitleGuidesSectionMeetingInRealLifeArticleTwo(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life.article.two',
            params
        );
    },
    lxSeoPageTitleGuidesSectionMeetingInRealLifeArticleThree(params: {
        page_partner_name: string;
    }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.meeting_in_real_life.article.three',
            params
        );
    },

    lxSeoPageTitleGuidesSectionSafetyTips(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.safety_tips',
            params
        );
    },
    lxSeoPageTitleGuidesSectionSafetyTipsArticleTwo(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.safety_tips.article.two',
            params
        );
    },
    lxSeoPageTitleGuidesSectionSafetyTipsArticleThree(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.safety_tips.article.three',
            params
        );
    },
    lxSeoPageTitleGuidesSectionSafetyTipsArticleFourth(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.safety_tips.article.fourth',
            params
        );
    },
    lxSeoPageTitleGuidesSectionSafetyTipsArticleFifth(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.safety_tips.article.fifth',
            params
        );
    },

    lxSeoPageTitleGuidesSectionMentalWellbeing(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.mental_wellbeing',
            params
        );
    },
    lxSeoPageTitleGuidesSectionMentalWellbeingArticleTwo(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.two',
            params
        );
    },
    lxSeoPageTitleGuidesSectionMentalWellbeingArticleThree(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.three',
            params
        );
    },
    lxSeoPageTitleGuidesSectionMentalWellbeingArticleFourth(params: { page_partner_name: string }) {
        return Localization.get(
            'badoo_safety_center@seo.page.title.guides.section.mental_wellbeing.article.fourth',
            params
        );
    },
};
